import DatePicker from 'react-datepicker';

import classes from './ModalDatePickerNewDesign.module.css';
import 'react-datepicker/dist/react-datepicker.css';
import { enGB, es, de, fr } from 'date-fns/locale';

const localeMap: any = {
  en: enGB,
  es: es,
  de: de,
  fr: fr,
};

type Props = {
  label: string;
  value: Date;
  onChange: any;
  disabled?: boolean;
  placeholder?: string;
  errorValidation?: boolean;
  width?: string;
  required?: boolean;
};

const ModalDatePickerNewDesign: React.FC<Props> = ({
  label,
  value,
  onChange,
  disabled,
  placeholder,
  errorValidation,
  width = '100%',
  required = false,
}) => {

  const lang = localStorage.getItem('lang') || 'en';

  return (
    <div
      className={classes.container}
      style={{ width: width, pointerEvents: disabled ? 'none' : 'auto' }}
    >
      <div className={classes.labelContainer}>
        <div className={classes.label}>{label}</div>
        {required && <div className={classes.labelAsterix}>*</div>}
      </div>
      <DatePicker
        className={!errorValidation ? classes.datePicker : classes.errorValidation}
        placeholderText={placeholder}
        yearDropdownItemNumber={100}
        selected={value}
        onChange={onChange}
        showYearDropdown={true}
        dateFormat={['dd.MM.yyyy', 'dd.MM.yyyy']}
        maxDate={new Date()}
        scrollableYearDropdown={true}
        locale={localeMap[lang]}
      />
    </div>
  );
};

export default ModalDatePickerNewDesign;
